var map = {
	"./a-i-limiter_256.png": "O1/o",
	"./a-i-limiter_64.png": "fX7a",
	"./adaptive-control-unit_256.png": "IsY1",
	"./adaptive-control-unit_64.png": "Wz3I",
	"./alclad-aluminum-sheet_256.png": "759m",
	"./alclad-aluminum-sheet_64.png": "Yd2l",
	"./alien-carapace_256.png": "CFfy",
	"./alien-carapace_64.png": "JLjM",
	"./alien-organs_256.png": "+0Py",
	"./alien-organs_64.png": "dgBK",
	"./alumina-solution_256.png": "DtHn",
	"./alumina-solution_64.png": "zLF2",
	"./aluminum-ingot_256.png": "tFZ/",
	"./aluminum-ingot_64.png": "ZaIK",
	"./aluminum-scrap_256.png": "2RsS",
	"./aluminum-scrap_64.png": "7sLp",
	"./assembler_256.png": "4+OT",
	"./assembler_64.png": "65la",
	"./automated-wiring_256.png": "Ciz0",
	"./automated-wiring_64.png": "O2ks",
	"./awesome-shop_256.png": "e3sC",
	"./awesome-shop_64.png": "fp+z",
	"./awesome-sink_256.png": "87T4",
	"./awesome-sink_64.png": "heii",
	"./bacon-agaric_256.png": "lW9o",
	"./bacon-agaric_64.png": "q+t0",
	"./battery_256.png": "FwVB",
	"./battery_64.png": "RHm2",
	"./bauxite_256.png": "xM7n",
	"./bauxite_64.png": "E9vX",
	"./beacon_256.png": "3n94",
	"./beacon_64.png": "mf3a",
	"./beryl-nut_256.png": "CA1c",
	"./beryl-nut_64.png": "FXf+",
	"./biomass-burner_256.png": "CAor",
	"./biomass-burner_64.png": "zgaJ",
	"./biomass_256.png": "V4zN",
	"./biomass_64.png": "I+Pb",
	"./black-powder_256.png": "qZAz",
	"./black-powder_64.png": "/3fO",
	"./blade-runners_256.png": "IW9o",
	"./blade-runners_64.png": "6C8x",
	"./cable_256.png": "k3+z",
	"./cable_64.png": "qSEg",
	"./caterium-ingot_256.png": "B0l0",
	"./caterium-ingot_64.png": "rcdQ",
	"./caterium-ore_256.png": "RshL",
	"./caterium-ore_64.png": "hhjf",
	"./center-door-wall-steel_256.png": "MBUj",
	"./center-door-wall-steel_64.png": "2T62",
	"./center-door-wall_256.png": "5+LF",
	"./center-door-wall_64.png": "OFeV",
	"./chainsaw_256.png": "FmGj",
	"./chainsaw_64.png": "Hj8p",
	"./circuit-board_256.png": "YGMS",
	"./circuit-board_64.png": "9tKQ",
	"./coal-generator_256.png": "w9WZ",
	"./coal-generator_64.png": "28yO",
	"./coal_256.png": "GeTg",
	"./coal_64.png": "iFKJ",
	"./color-cartridge_256.png": "3utI",
	"./color-cartridge_64.png": "PEFZ",
	"./color-gun_256.png": "OEM4",
	"./color-gun_64.png": "x4K3",
	"./compacted-coal_256.png": "3JeK",
	"./compacted-coal_64.png": "J7bT",
	"./computer_256.png": "1A9U",
	"./computer_64.png": "ScLz",
	"./concrete_256.png": "D1xR",
	"./concrete_64.png": "cy7D",
	"./constructor_256.png": "h3TN",
	"./constructor_64.png": "ZbZJ",
	"./conveyor-belt-mk-1_256.png": "yfBy",
	"./conveyor-belt-mk-1_64.png": "i90B",
	"./conveyor-belt-mk-2_256.png": "yTsg",
	"./conveyor-belt-mk-2_64.png": "PAea",
	"./conveyor-belt-mk-3_256.png": "FPOc",
	"./conveyor-belt-mk-3_64.png": "6Fqb",
	"./conveyor-belt-mk-4_256.png": "pIO0",
	"./conveyor-belt-mk-4_64.png": "rGfm",
	"./conveyor-belt-mk-5_256.png": "Fh/K",
	"./conveyor-belt-mk-5_64.png": "ExDp",
	"./conveyor-lift-mk-1_256.png": "4UQK",
	"./conveyor-lift-mk-1_64.png": "cDvE",
	"./conveyor-lift-mk-2_256.png": "e6bX",
	"./conveyor-lift-mk-2_64.png": "mIrW",
	"./conveyor-lift-mk-3_256.png": "oUXm",
	"./conveyor-lift-mk-3_64.png": "0B9d",
	"./conveyor-lift-mk-4_256.png": "Mgzi",
	"./conveyor-lift-mk-4_64.png": "kPkO",
	"./conveyor-lift-mk-5_256.png": "THWp",
	"./conveyor-lift-mk-5_64.png": "hsBC",
	"./conveyor-merger_256.png": "GFeh",
	"./conveyor-merger_64.png": "uL53",
	"./conveyor-pole_256.png": "//a8",
	"./conveyor-pole_64.png": "yG77",
	"./conveyor-splitter_256.png": "h5m9",
	"./conveyor-splitter_64.png": "ucdd",
	"./conveyor-wall-mount_256.png": "N4Cq",
	"./conveyor-wall-mount_64.png": "FvbG",
	"./copper-ingot_256.png": "h+gf",
	"./copper-ingot_64.png": "Zkox",
	"./copper-ore_256.png": "lY0u",
	"./copper-ore_64.png": "8XJb",
	"./copper-sheet_256.png": "iMnS",
	"./copper-sheet_64.png": "KTLD",
	"./coupon_256.png": "zFUI",
	"./coupon_64.png": "ajHi",
	"./craft-bench_256.png": "UFqj",
	"./craft-bench_64.png": "DOcV",
	"./crude-oil_256.png": "WzHx",
	"./crude-oil_64.png": "y8br",
	"./crystal-oscillator_256.png": "fiaO",
	"./crystal-oscillator_64.png": "0qPt",
	"./cyber-wagon_256.png": "taev",
	"./cyber-wagon_64.png": "KCSK",
	"./display_256.png": "Zcs+",
	"./double-ramp-8m-x-2m_256.png": "MPVI",
	"./double-ramp-8m-x-2m_64.png": "eien",
	"./double-ramp-8m-x-4m_256.png": "0/y/",
	"./double-ramp-8m-x-4m_64.png": "mAwJ",
	"./double-ramp-8m-x-8m_256.png": "zVhp",
	"./double-ramp-8m-x-8m_64.png": "qvAF",
	"./double-wall-outlet-mk-1_256.png": "cbF4",
	"./double-wall-outlet-mk-1_64.png": "xuCp",
	"./double-wall-outlet-mk-2_256.png": "aKOy",
	"./double-wall-outlet-mk-2_64.png": "jbPv",
	"./double-wall-outlet-mk-3_256.png": "S5Ms",
	"./double-wall-outlet-mk-3_64.png": "V2tj",
	"./down-corner-8m-x-1m-inverted_256.png": "4bPs",
	"./down-corner-8m-x-1m-inverted_64.png": "Uofk",
	"./down-corner-8m-x-2m-inverted_256.png": "FVZr",
	"./down-corner-8m-x-2m-inverted_64.png": "gzgu",
	"./down-corner-8m-x-4m-inverted_256.png": "W/dW",
	"./down-corner-8m-x-4m-inverted_64.png": "HI8F",
	"./down-corner-ramp-8m-x-1m_256.png": "rI8F",
	"./down-corner-ramp-8m-x-1m_64.png": "WWsl",
	"./down-corner-ramp-8m-x-2m_256.png": "Avj8",
	"./down-corner-ramp-8m-x-2m_64.png": "L8sU",
	"./down-corner-ramp-8m-x-4m_256.png": "PXVX",
	"./down-corner-ramp-8m-x-4m_64.png": "FfDI",
	"./electric-locomotive_256.png": "T6y5",
	"./electric-locomotive_64.png": "yjEV",
	"./electrical-components_256.png": "00Uf",
	"./electromagnetic-control-rod_256.png": "Mw2B",
	"./electromagnetic-control-rod_64.png": "HLcV",
	"./empty-canister_256.png": "mAg9",
	"./empty-canister_64.png": "Vw6N",
	"./empty-platform_256.png": "O/3m",
	"./empty-platform_64.png": "a3Ho",
	"./encased-industrial-beam_256.png": "0gY7",
	"./encased-industrial-beam_64.png": "OrL8",
	"./encased-uranium-cell_256.png": "WDZn",
	"./encased-uranium-cell_64.png": "0ZWI",
	"./energy_256.png": "dURV",
	"./equipment-workshop_256.png": "M7HP",
	"./equipment-workshop_64.png": "+zpH",
	"./explorer_256.png": "H4sV",
	"./explorer_64.png": "6qK0",
	"./fabric_256.png": "s+cp",
	"./fabric_64.png": "nOdD",
	"./factory-cart_256.png": "9coI",
	"./factory-cart_64.png": "0u8O",
	"./fence_256.png": "HVws",
	"./fence_64.png": "VLbl",
	"./flower-petals_256.png": "6HRs",
	"./flower-petals_64.png": "EOr6",
	"./fluid-buffer_256.png": "NBXI",
	"./fluid-buffer_64.png": "YlYM",
	"./fluid-freight-platform_256.png": "f0ZY",
	"./fluid-freight-platform_64.png": "vJv+",
	"./foundation-8m-x-1m_256.png": "HUst",
	"./foundation-8m-x-1m_64.png": "zpox",
	"./foundation-8m-x-2m_256.png": "A/Vx",
	"./foundation-8m-x-2m_64.png": "RzE9",
	"./foundation-8m-x-4m_256.png": "Wgka",
	"./foundation-8m-x-4m_64.png": "Plzi",
	"./foundry_256.png": "Eu07",
	"./foundry_64.png": "3net",
	"./frame-foundation-8m-x-4m_256.png": "k0oU",
	"./frame-foundation-8m-x-4m_64.png": "/F3m",
	"./frame-window_256.png": "5Hf8",
	"./frame-window_64.png": "/by8",
	"./freight-car_256.png": "AMZq",
	"./freight-car_64.png": "L1XM",
	"./freight-platform_256.png": "j1q/",
	"./freight-platform_64.png": "nbpa",
	"./fuel-generator_256.png": "Y5/t",
	"./fuel-generator_64.png": "Vo0u",
	"./fuel_256.png": "Ghv5",
	"./fuel_64.png": "lTQS",
	"./gas-filter_256.png": "WfbD",
	"./gas-filter_64.png": "B6i/",
	"./gas-mask_256.png": "rhFw",
	"./gas-mask_64.png": "Y9UO",
	"./gate-wall_256.png": "scBL",
	"./gate-wall_64.png": "nG/D",
	"./geothermal-generator_256.png": "f6tN",
	"./geothermal-generator_64.png": "Lh3X",
	"./glass-foundation-8m-x-1m_256.png": "+hkI",
	"./glass-foundation-8m-x-1m_64.png": "uSbM",
	"./green-power-slug_256.png": "0HjJ",
	"./green-power-slug_64.png": "hyPu",
	"./hazmat-suit_256.png": "4zg/",
	"./hazmat-suit_64.png": "nGJT",
	"./heat-sink_256.png": "PBGr",
	"./heat-sink_64.png": "wTRz",
	"./heavy-modular-frame_256.png": "Utjg",
	"./heavy-modular-frame_64.png": "ce4l",
	"./heavy-oil-residue_256.png": "QhtP",
	"./heavy-oil-residue_64.png": "5TK9",
	"./high-speed-connector_256.png": "fzh1",
	"./high-speed-connector_64.png": "5/we",
	"./hub-parts_256.png": "7s91",
	"./hub-parts_64.png": "7ccs",
	"./hyper-tube-entrance_256.png": "Mjn0",
	"./hyper-tube-entrance_64.png": "ZCcM",
	"./hyper-tube-support_256.png": "N7EL",
	"./hyper-tube-support_64.png": "WC/B",
	"./hyper-tube-wall-hole_256.png": "OViV",
	"./hyper-tube-wall-hole_64.png": "H9j4",
	"./hyper-tube-wall-support_256.png": "LpSn",
	"./hyper-tube-wall-support_64.png": "gecD",
	"./hyper-tube_256.png": "yP3V",
	"./hyper-tube_64.png": "z5DQ",
	"./industrial-fluid-buffer_256.png": "N1MF",
	"./industrial-fluid-buffer_64.png": "AhzV",
	"./industrial-storage-container_256.png": "rGbk",
	"./industrial-storage-container_64.png": "Z7li",
	"./inner-corner-quarter-pipe_256.png": "FjN0",
	"./inner-corner-quarter-pipe_64.png": "8ifd",
	"./inverted-inner-corner-quarter-pipe_256.png": "Qi1K",
	"./inverted-inner-corner-quarter-pipe_64.png": "++h1",
	"./inverted-outer-corner-quarter-pipe_256.png": "Swk0",
	"./inverted-outer-corner-quarter-pipe_64.png": "8UZY",
	"./inverted-quarter-pipe_256.png": "6NbT",
	"./inverted-quarter-pipe_64.png": "6UCj",
	"./inverted-ramp-8m-x-1m_256.png": "dL9N",
	"./inverted-ramp-8m-x-1m_64.png": "/KnV",
	"./inverted-ramp-8m-x-2m_256.png": "8OO6",
	"./inverted-ramp-8m-x-2m_64.png": "iBbT",
	"./inverted-ramp-8m-x-4m_256.png": "U4Lf",
	"./inverted-ramp-8m-x-4m_64.png": "9LbR",
	"./iodine-infused-filter_256.png": "1ngw",
	"./iodine-infused-filter_64.png": "6PzM",
	"./iron-ingot_256.png": "nviP",
	"./iron-ingot_64.png": "YwuD",
	"./iron-ore_256.png": "RhwD",
	"./iron-ore_64.png": "g5cN",
	"./iron-plate_256.png": "7Mbm",
	"./iron-plate_64.png": "jXKk",
	"./iron-rod_256.png": "JORU",
	"./iron-rod_64.png": "guy/",
	"./jetpack_256.png": "0TvY",
	"./jetpack_64.png": "KVG8",
	"./jump-pad_256.png": "skiq",
	"./jump-pad_64.png": "h+9G",
	"./leaves_256.png": "WqH/",
	"./leaves_64.png": "ewps",
	"./left-door-wall-steel_256.png": "4jUq",
	"./left-door-wall-steel_64.png": "B1HJ",
	"./left-door-wall_256.png": "MN2T",
	"./left-door-wall_64.png": "71Cv",
	"./limestone_256.png": "Tgj6",
	"./limestone_64.png": "Jdw1",
	"./liquid-biofuel_256.png": "zs0I",
	"./liquid-biofuel_64.png": "Bavu",
	"./lookout-tower_256.png": "Yo1a",
	"./lookout-tower_64.png": "PGu4",
	"./m-a-m-_256.png": "0T6n",
	"./m-a-m-_64.png": "9Vta",
	"./manufacturer_256.png": "jZwC",
	"./manufacturer_64.png": "2taI",
	"./medicinal-inhaler_256.png": "aDcY",
	"./medicinal-inhaler_64.png": "l2ZQ",
	"./memory_256.png": "CCbG",
	"./microchip_256.png": "8VI9",
	"./miner-mk-1_256.png": "B/W7",
	"./miner-mk-1_64.png": "DMd6",
	"./miner-mk-2_256.png": "f1Cq",
	"./miner-mk-2_64.png": "ZtSv",
	"./miner-mk-3_256.png": "mEyV",
	"./miner-mk-3_64.png": "H7pl",
	"./modular-engine_256.png": "yjn9",
	"./modular-engine_64.png": "pLmp",
	"./modular-frame_256.png": "kBWg",
	"./modular-frame_64.png": "lSvc",
	"./motor_256.png": "R2v5",
	"./motor_64.png": "++tU",
	"./mycelia_256.png": "i7Eq",
	"./mycelia_64.png": "uinH",
	"./nobelisk-detonator_256.png": "eCpx",
	"./nobelisk-detonator_64.png": "lKvP",
	"./nobelisk_256.png": "eC1G",
	"./nobelisk_64.png": "nNHa",
	"./nuclear-fuel-rod_256.png": "vHU0",
	"./nuclear-fuel-rod_64.png": "VXZw",
	"./nuclear-power-plant_256.png": "LuxQ",
	"./nuclear-power-plant_64.png": "tNK3",
	"./nuclear-waste_256.png": "7Sua",
	"./nuclear-waste_64.png": "AyNK",
	"./object-scanner_256.png": "gYHo",
	"./object-scanner_64.png": "Hs0D",
	"./oil-extractor_256.png": "r/D0",
	"./oil-extractor_64.png": "R+W2",
	"./outer-corner-quarter-pipe_256.png": "LLV7",
	"./outer-corner-quarter-pipe_64.png": "Fjym",
	"./packaged-fuel_256.png": "bs8W",
	"./packaged-fuel_64.png": "eRim",
	"./packaged-heavy-oil-residue_256.png": "+Ewe",
	"./packaged-heavy-oil-residue_64.png": "Okfn",
	"./packaged-liquid-biofuel_256.png": "e2QL",
	"./packaged-liquid-biofuel_64.png": "IG4P",
	"./packaged-oil_256.png": "vCff",
	"./packaged-oil_64.png": "p1DS",
	"./packaged-turbofuel_256.png": "3dZ5",
	"./packaged-turbofuel_64.png": "Uow3",
	"./packaged-water_256.png": "NPjW",
	"./packaged-water_64.png": "d87h",
	"./paleberry_256.png": "sIAz",
	"./paleberry_64.png": "gAD1",
	"./panel-window_256.png": "VK6w",
	"./panel-window_64.png": "9WI5",
	"./parachute_256.png": "TfRe",
	"./parachute_64.png": "yzJV",
	"./personal-storage-box_256.png": "hOk4",
	"./personal-storage-box_64.png": "mW4I",
	"./petroleum-coke_256.png": "k5Cu",
	"./petroleum-coke_64.png": "mOhP",
	"./pillar-base_256.png": "I/3r",
	"./pillar-base_64.png": "pQ29",
	"./pillar-middle_256.png": "NcQG",
	"./pillar-middle_64.png": "DmGX",
	"./pillar-top_256.png": "zEcj",
	"./pillar-top_64.png": "4HX8",
	"./pipeline-junction-cross_256.png": "jLcl",
	"./pipeline-junction-cross_64.png": "44Gz",
	"./pipeline-pump_256.png": "139B",
	"./pipeline-pump_64.png": "N7YA",
	"./pipeline-support_256.png": "x9wr",
	"./pipeline-support_64.png": "Y6VT",
	"./pipeline-wall-hole_256.png": "3VPH",
	"./pipeline-wall-hole_64.png": "cC7i",
	"./pipeline-wall-support_256.png": "RQGB",
	"./pipeline-wall-support_64.png": "ytMD",
	"./pipeline_256.png": "8kCM",
	"./pipeline_64.png": "dNLN",
	"./plastic_256.png": "MRkQ",
	"./plastic_64.png": "5iD9",
	"./polymer-resin_256.png": "pzId",
	"./polymer-resin_64.png": "spN+",
	"./portable-miner_256.png": "esT3",
	"./portable-miner_64.png": "RMly",
	"./power-line_256.png": "RiXP",
	"./power-line_64.png": "zTFR",
	"./power-pole-mk-1_256.png": "ozFE",
	"./power-pole-mk-1_64.png": "bzQG",
	"./power-pole-mk-2_256.png": "lhfu",
	"./power-pole-mk-2_64.png": "u7JJ",
	"./power-pole-mk-3_256.png": "OtbO",
	"./power-pole-mk-3_64.png": "NGMK",
	"./power-shard_256.png": "cgg9",
	"./power-shard_64.png": "5Zu2",
	"./programmable-splitter_256.png": "0NXV",
	"./programmable-splitter_64.png": "5vgs",
	"./purple-power-slug_256.png": "Akk5",
	"./purple-power-slug_64.png": "Xw+4",
	"./quarter-pipe_256.png": "h4mj",
	"./quarter-pipe_64.png": "p+nU",
	"./quartz-crystal_256.png": "lV+7",
	"./quartz-crystal_64.png": "JA9e",
	"./question-mark.png": "7zp2",
	"./quickwire_256.png": "8sgc",
	"./quickwire_64.png": "QiZL",
	"./radar-tower_256.png": "0zo7",
	"./radar-tower_64.png": "1LfK",
	"./radio-control-unit_256.png": "bbE0",
	"./radio-control-unit_64.png": "xGox",
	"./railway_256.png": "YPOa",
	"./railway_64.png": "WO1V",
	"./ramp-8m-x-1m_256.png": "yHtb",
	"./ramp-8m-x-1m_64.png": "zNMe",
	"./ramp-8m-x-2m_256.png": "BmRk",
	"./ramp-8m-x-2m_64.png": "EqmK",
	"./ramp-8m-x-4m_256.png": "Dh5/",
	"./ramp-8m-x-4m_64.png": "DHaG",
	"./raw-quartz_256.png": "SDEq",
	"./raw-quartz_64.png": "PaNK",
	"./rebar-gun_256.png": "3GVy",
	"./rebar-gun_64.png": "x6Ur",
	"./refinery_256.png": "tXn9",
	"./refinery_64.png": "ZSFe",
	"./reinforced-iron-plate_256.png": "mWW8",
	"./reinforced-iron-plate_64.png": "Jr2A",
	"./reinforced-window_256.png": "drVv",
	"./reinforced-window_64.png": "pcu1",
	"./rifle-cartridge_256.png": "msLJ",
	"./rifle-cartridge_64.png": "84LN",
	"./rifle_256.png": "C/rl",
	"./rifle_64.png": "2G7X",
	"./right-door-wall-steel_256.png": "TZj9",
	"./right-door-wall-steel_64.png": "h71P",
	"./right-door-wall_256.png": "eOA4",
	"./right-door-wall_64.png": "B4X2",
	"./rotor_256.png": "c/V7",
	"./rotor_64.png": "Tt0v",
	"./rubber_256.png": "H5xI",
	"./rubber_64.png": "RuAw",
	"./screw_256.png": "CTyl",
	"./screw_64.png": "tdg5",
	"./ship-battleship_256.png": "eRkX",
	"./ship-cargo_256.png": "d5hL",
	"./ship-cruiser_256.png": "1Q+t",
	"./ship-mosquito_256.png": "PDxy",
	"./ship-shuttle_256.png": "uKAl",
	"./ship-transport_256.png": "m6fk",
	"./ship-wasp_256.png": "84KG",
	"./silica_256.png": "cTEu",
	"./silica_64.png": "QOt4",
	"./single-window_256.png": "saX2",
	"./single-window_64.png": "I1ww",
	"./smart-plating_256.png": "2XXZ",
	"./smart-plating_64.png": "tKYj",
	"./smart-splitter_256.png": "9X6k",
	"./smart-splitter_64.png": "70YK",
	"./smelter_256.png": "QrhS",
	"./smelter_64.png": "rd+O",
	"./solid-biofuel_256.png": "iO/X",
	"./solid-biofuel_64.png": "Hufn",
	"./space-elevator_256.png": "tfQS",
	"./space-elevator_64.png": "brMM",
	"./spiked-rebar_256.png": "72f4",
	"./spiked-rebar_64.png": "wRRE",
	"./stackable-conveyor-pole_256.png": "RFD6",
	"./stackable-conveyor-pole_64.png": "hwU1",
	"./stackable-hyper-tube-support_256.png": "eed5",
	"./stackable-hyper-tube-support_64.png": "wwNo",
	"./stackable-pipeline-support_256.png": "czo+",
	"./stackable-pipeline-support_64.png": "Sstp",
	"./stairs-left_256.png": "bqoJ",
	"./stairs-left_64.png": "GUgj",
	"./stairs-right_256.png": "YVTI",
	"./stairs-right_64.png": "X7Nc",
	"./stator_256.png": "ujRy",
	"./stator_64.png": "cDB+",
	"./steel-beam_256.png": "Al0R",
	"./steel-beam_64.png": "qNFh",
	"./steel-ingot_256.png": "yyYZ",
	"./steel-ingot_64.png": "kw+X",
	"./steel-pipe_256.png": "POWR",
	"./steel-pipe_64.png": "EmTS",
	"./steel-plate_256.png": "LrRY",
	"./storage-container_256.png": "oSH5",
	"./storage-container_64.png": "tYpD",
	"./sulfur_256.png": "NCma",
	"./sulfur_64.png": "T/K9",
	"./sulfuric-acid_256.png": "ZLFJ",
	"./sulfuric-acid_64.png": "H1nE",
	"./supercomputer_256.png": "e0xA",
	"./supercomputer_64.png": "OYvW",
	"./the-hub_256.png": "Ear1",
	"./the-hub_64.png": "7iLh",
	"./tilted-jump-pad_256.png": "bCVT",
	"./tilted-jump-pad_64.png": "RU7F",
	"./tractor_256.png": "r/0b",
	"./tractor_64.png": "UaUg",
	"./train-station_256.png": "9/cy",
	"./train-station_64.png": "yMCP",
	"./transistor_256.png": "c1OW",
	"./truck-station_256.png": "BkUR",
	"./truck-station_64.png": "Nf0K",
	"./truck_256.png": "B33K",
	"./truck_64.png": "M/g0",
	"./turbo-motor_256.png": "fuOc",
	"./turbo-motor_64.png": "oMdI",
	"./turbofuel_256.png": "kQuH",
	"./turbofuel_64.png": "qsgL",
	"./u-jelly-landing-pad_256.png": "Mrwo",
	"./u-jelly-landing-pad_64.png": "Dwc/",
	"./up-corner-8m-x-1m-inverted_256.png": "3n+C",
	"./up-corner-8m-x-1m-inverted_64.png": "gUvp",
	"./up-corner-8m-x-2m-inverted_256.png": "30tj",
	"./up-corner-8m-x-2m-inverted_64.png": "Outv",
	"./up-corner-8m-x-4m-inverted_256.png": "NQ1T",
	"./up-corner-8m-x-4m-inverted_64.png": "jimc",
	"./up-corner-ramp-8m-x-1m_256.png": "IRQT",
	"./up-corner-ramp-8m-x-1m_64.png": "tuZ0",
	"./up-corner-ramp-8m-x-2m_256.png": "qXLs",
	"./up-corner-ramp-8m-x-2m_64.png": "LLzQ",
	"./up-corner-ramp-8m-x-4m_256.png": "r5bx",
	"./up-corner-ramp-8m-x-4m_64.png": "wfEF",
	"./uranium-pellet_256.png": "p537",
	"./uranium-pellet_64.png": "tlMh",
	"./uranium_256.png": "eRXl",
	"./uranium_64.png": "JDKR",
	"./versatile-framework_256.png": "xEwI",
	"./versatile-framework_64.png": "OVtK",
	"./walkway-crossing_256.png": "3MF8",
	"./walkway-crossing_64.png": "4pZZ",
	"./walkway-ramp_256.png": "3Q3r",
	"./walkway-ramp_64.png": "Qxup",
	"./walkway-straight_256.png": "uf4J",
	"./walkway-straight_64.png": "Mcew",
	"./walkway-t-crossing_256.png": "tSUD",
	"./walkway-t-crossing_64.png": "J9Ct",
	"./walkway-turn_256.png": "nyIy",
	"./walkway-turn_64.png": "qhLI",
	"./wall-8m-x-4m-steel_256.png": "t8Pi",
	"./wall-8m-x-4m-steel_64.png": "hGic",
	"./wall-8m-x-4m_256.png": "we96",
	"./wall-8m-x-4m_64.png": "2H9N",
	"./wall-conveyor-perpendicular-steel_256.png": "PtuR",
	"./wall-conveyor-perpendicular-steel_64.png": "xXZY",
	"./wall-conveyor-perpendicular_256.png": "UtxJ",
	"./wall-conveyor-perpendicular_64.png": "nfwQ",
	"./wall-conveyor-x1-steel_256.png": "0ZBq",
	"./wall-conveyor-x1-steel_64.png": "37oS",
	"./wall-conveyor-x1_256.png": "NJC2",
	"./wall-conveyor-x1_64.png": "0haN",
	"./wall-conveyor-x2-steel_256.png": "Td6j",
	"./wall-conveyor-x2-steel_64.png": "Gh+d",
	"./wall-conveyor-x2_256.png": "c3Py",
	"./wall-conveyor-x2_64.png": "7ZOM",
	"./wall-conveyor-x3-steel_256.png": "2OwC",
	"./wall-conveyor-x3-steel_64.png": "h+KN",
	"./wall-conveyor-x3_256.png": "bjVq",
	"./wall-conveyor-x3_64.png": "O6mP",
	"./wall-outlet-mk-1_256.png": "qv7w",
	"./wall-outlet-mk-1_64.png": "sfw9",
	"./wall-outlet-mk-2_256.png": "Q8/N",
	"./wall-outlet-mk-2_64.png": "IqIw",
	"./wall-outlet-mk-3_256.png": "Yfbb",
	"./wall-outlet-mk-3_64.png": "yY6T",
	"./water-extractor_256.png": "rQif",
	"./water-extractor_64.png": "O2mo",
	"./water_256.png": "riX0",
	"./water_64.png": "eNgc",
	"./wire_256.png": "6K1e",
	"./wire_64.png": "yO9g",
	"./wood_256.png": "8Pjb",
	"./wood_64.png": "Ecx0",
	"./xeno-basher_256.png": "waPX",
	"./xeno-basher_64.png": "HfJQ",
	"./xeno-zapper_256.png": "U6eo",
	"./xeno-zapper_64.png": "Y5HX",
	"./yellow-power-slug_256.png": "QH/S",
	"./yellow-power-slug_64.png": "Cwxb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 0